import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CountByOnboardingStage, Publisher } from '../domain/publisher.model';
import { ScaledPartnershipStatus } from '../domain/scaled-partnership-status.enum';
import { IoExecutedStatus } from '../domain/io-executed-status.enum';
import { HttpUtils } from '../utils/http-utils';


@Injectable()
export class AdStatsPublisherOnboardingService {

  constructor(private http: HttpClient) {
  }

  onboardingStageCount(): Observable<CountByOnboardingStage[]> {
    return this.http.get<CountByOnboardingStage[]>(`${environment.serviceUrl}/ad-stats/adu/publisher/onboarding-stage-count`);
  }

  sendWelcomeEmail(id: string): Observable<Publisher> {
    return this.http.get<Publisher>(`${environment.serviceUrl}/ad-stats/adu/publisher/${id}/onboarding/send-welcome-email`);
  }

  ioRequested(id: string): Observable<Publisher> {
    return this.http.put<Publisher>(`${environment.serviceUrl}/ad-stats/adu/publisher/${id}/onboarding/io-requested`, null);
  }

  ioSent(id: string): Observable<Publisher> {
    return this.http.put<Publisher>(`${environment.serviceUrl}/ad-stats/adu/publisher/${id}/onboarding/io-sent`, null);
  }

  ioExecuted(id: string, status: IoExecutedStatus): Observable<Publisher> {
    return this.http.put<Publisher>(`${environment.serviceUrl}/ad-stats/adu/publisher/${id}/onboarding/io-executed`, null, {
      params: HttpUtils.getHttpParams({status})
    });
  }

  scaledPartnership(id: string, status: ScaledPartnershipStatus): Observable<Publisher> {
    return this.http.put<Publisher>(`${environment.serviceUrl}/ad-stats/adu/publisher/${id}/onboarding/scaled-partnership?status=${status}`, null);
  }

  koCallDone(id: string): Observable<Publisher> {
    return this.http.put<Publisher>(`${environment.serviceUrl}/ad-stats/adu/publisher/${id}/onboarding/ko-call-done`, null);
  }

}

